// react
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'

// css
import './styles.scss'

// dependencies
import {
  Button,
  BUTTON_THEME,
  BUTTON_SIZE,
  Input,
  BarLoader,
} from '@st-operations/uikit/src/v2/index.js'

// libraries
import User from '../../lib/User'
import { useNavigationContext } from '../../contexts/NavigationContext.jsx'

// page
const ForgotPasswordPage = ({ logo, domain }) => {
  const { setShowSidebar, setShowContentContainer } = useNavigationContext()

  const [state, setState] = useState({
    email: '',
    errorMsg: '',
    loading: false,
  })

  useEffect(() => {
    setShowSidebar(false)
    setShowContentContainer(false)
  }, [])

  const sendResetLink = () => {
    // missing email
    if (!state.email) {
      setState((prevState) => ({ ...prevState, errorMsg: `missing 'email'` }))
    }
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }))

    User.forgotPassword(state.email, domain, (err) => {
      setTimeout(() => setState((prevState) => ({ ...prevState, loading: false })), 1000)
      if (err) {
        setState((prevState) => ({ ...prevState, errorMsg: err.message }))
        setTimeout(() => {
          setState((prevState) => ({ ...prevState, errorMsg: '' }))
        }, 4000)
      } else {
        let msg = `You should receive an email with a link to reset your pass
        word shortly`
        toast(msg, { autoClose: 2500, position: 'top-right' })
      }
    })
  }

  const onEmailChange = (value) => {
    setState({ email: value })
  }

  const onEmailKeyPress = (e) => {
    if (e.key === 'Enter') {
      sendResetLink()
    }
  }

  return (
    <div id="st-forgot-password-page">
      <div className="st-forgot-password-page__content">
        <div className="st-forgot-password-page__logo">
          <img src={logo} />
        </div>

        <div className="st-forgot-password-page__title">Reset Password</div>
        <If condition={state.errorMsg && !state.loading}>
          <div className="st-forgot-password-page__error-msg">{state.errorMsg}</div>
        </If>
        <Input
          onChange={onEmailChange}
          onKeyPress={onEmailKeyPress}
          placeholder="Enter Email Here"
          value={state.email}
        />
        <BarLoader
          containerStyle={{ opacity: state.loading ? 1 : 0, width: 300, margin: '0 auto' }}
        />

        <Button size={BUTTON_SIZE.LARGE} theme={BUTTON_THEME.SECONDARY} onClick={sendResetLink}>
          Send Reset Link
        </Button>
      </div>
    </div>
  )
}

ForgotPasswordPage.propTypes = {
  domain: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
}

// export
export default React.memo(ForgotPasswordPage)
